////////// READ BEFORE EDITING THIS FILE !! //////////
// The configuration on this file needs to match the configuration on L2E's DataExportComposer
// Any edits to this file need to transfered to the DataExportComposer as well

var StudentMetrics = require("lib/data/StudentMetrics");
var DataRouting = require("lib/routing/DataRouting");

export var TEACHER = 'teacher'
export var ADMIN = 'admin'
export var PER_STUDENT = 'per-student'
export var PER_CLASS = 'per-class'
export var PER_TEACHER = 'per-teacher'
export var CHRONO = 'chrono'

export var QUIZZES = 'quizzes'
export var GOALS = 'goals'
export var PRACTICE_QUESTIONS = 'practice_questions'
export var REVIEWS = 'reviews'
export var BOOKS = 'books'
export var ACTIVITIES = 'activities'
export var READING_LOGS = 'reading_logs'
export var ADDITIONAL_METRICS = 'additional_metrics'
export var ROSTER = 'roster'
export var ESSAYS = 'essays'

var QUIZ_RUBRIC = [
    { key: 'crit-evi-cote-bert-read-book-1', label: "Read Book" },
    { key: 'crit-rc-atq-coqa-fully-answered-2', label: "Fully Answered Question" },
    { key: 'crit-evi-cote-bert-quantity-14', label: "Text Details Count" },
    { key: 'crit-rc-atq-cors-bert-10', label: "Restated Question" }
]

var RUBRIC = [
    ...QUIZ_RUBRIC,
    { key: 'comm-conv-mech-caps-4', label: "Capitalization" },
    { key: 'comm-conv-mech-punc-8', label: "Punctuation" },
    { key: 'comm-conv-mech-spell-13', label: "Spelling" },
    { key: 'comm-conv-mech-gram-5', label: "Grammar" },
    { key: 'comm-conv-org-word-count-18', label: "Word Count" },
    { key: 'comm-conv-org-sent-count-11', label: "Sentence Count" },

]

export var METRICS_BY_CATEGORY = {
    [QUIZZES]: [
        { key: 'quiz-score', label: 'Quiz Score' },
        { key: 'lexile-level', label: 'Lexile Level' },
        ...QUIZ_RUBRIC
    ],
    [PRACTICE_QUESTIONS]: [
        { key: 'practice-question-score', label: 'Practice Question Score' },
        { key: 'lexile-level', label: 'Lexile Level' },
        ...RUBRIC
    ],
    [REVIEWS]: [
        { key: 'lexile-level', label: 'Lexile Level' },
        // ...RUBRIC
    ],
    [BOOKS]: [
        { key: 'lexile-level', label: 'Lexile Level' },
        { key: 'quiz-score', label: 'Quiz Score' },
        { key: 'crit-evi-cote-bert-read-book-1', label: "Read Book" },
        { key: 'review-count', label: 'Review Count' },
        { key: 'practice-question-count', label: 'Practice Question Count' },
        { key: 'exercise-count', label: 'Exercise Count' },
        { key: 'question-builder-count', label: 'Question Builder Count' },
    ],
    [ACTIVITIES]: [
        { key: 'assigned', label: 'Assigned' },
        { key: 'due-date', label: 'Due Date' },
        { key: 'text-title', label: 'Text Title' },
        { key: 'exercise-title', label: 'Exercise Title' },
        { key: 'skill-set', label: 'Skill Set' },
        { key: 'format', label: 'Format' },
        { key: 'completed-at', label: 'Completed At' },
    ],
    [READING_LOGS]: [
        { key: 'lexile-level', label: 'Lexile Level' },
        { key: 'minutes', label: "Minutes" },
        { key: 'pages', label: "Pages" },
    ],
    [GOALS]: [
        { key: 'quizzes-passed', label: 'Quizzes Passed' },
        { key: 'questions', label: 'Practice Questions' },
        { key: 'reviews', label: 'Reviews' },
        { key: 'exercises', label: 'Exercises' },
        { key: 'minutes', label: 'Minutes Logged' },
        { key: 'pages', label: 'Pages Read' },
        { key: 'days-active', label: 'Days Active' },
        { key: 'question-builder', label: 'Question Builders' },
        { key: 'essays', label: 'Essays' },
    ],
    [ADDITIONAL_METRICS]: [
        { label: 'Quizzes', children: StudentMetrics.quizMetrics() },
        { label: 'Writing', children: StudentMetrics.writingMetrics() },
        { label: 'Reading', children: StudentMetrics.readingMetrics() },
        { label: 'Other Metrics', children: StudentMetrics.otherMetrics() }
    ],
    [ROSTER]: [
        { key: 'username', label: 'Username' },
        { key: 'password', label: 'Password' },
        { key: 'primary_student_list', label: 'Primary Student List' },
        { key: 'all_student_lists', label: 'All Student Lists' },
        { key: 'grade_level', label: 'Grade Level' },
        { key: 'academic_level', label: 'Academic Grade' },
        { key: 'reading_level', label: 'Reading Level' }
    ],
}

export var CSV_ORGANIZATION_OPTIONS = {
    [TEACHER]: [
        { key: 'chrono', label: 'Chronologically' },
        { key: 'per-class', label: 'Per-Class' },
        { key: 'per-student', label: 'Per-Student' }
    ],

    [ADMIN]: [
        { key: 'chrono', label: 'Chronologically' },
        { key: 'per-teacher', label: 'Per-Teacher' },
        { key: 'per-class', label: 'Per-Class' },
        { key: 'per-student', label: 'Per-Student' }
    ],
}

export var DATE_PERIODS_BY_ORG_TYPE = {
    [CHRONO]: [
        { key: 'week', label: 'Week' },
        { key: 'month', label: 'Month' },
        { key: 'goal-period', label: 'Goal Period' }
    ],
    [PER_CLASS]: [
        { key: 'week', label: 'Week' },
        { key: 'month', label: 'Month' },
        { key: 'goal-period', label: 'Goal Period' },
        { key: 'custom', label: 'Custom' }
    ],
    [PER_STUDENT]: [
        { key: 'week', label: 'Week' },
        { key: 'month', label: 'Month' },
        { key: 'goal-period', label: 'Goal Period' },
        { key: 'custom', label: 'Custom' }
    ],
    [PER_TEACHER]: [
        { key: 'week', label: 'Week' },
        { key: 'month', label: 'Month' },
        { key: 'goal-period', label: 'Goal Period' },
        { key: 'custom', label: 'Custom' }
    ]
}

export var SUBJECT_TO_EXPORT_METRICS = {
    [DataRouting.SUBJECT_GOALS]: GOALS,
    [DataRouting.SUBJECT_OTHER_METRICS]: ADDITIONAL_METRICS,
    [DataRouting.SUBJECT_BOOKS]: BOOKS,
    [DataRouting.SUBJECT_LOG_LIST]: READING_LOGS,
    [DataRouting.SUBJECT_LOG_CALENDAR]: READING_LOGS,
    [DataRouting.SUBJECT_QUIZZES]: QUIZZES,
    [DataRouting.SUBJECT_WRITING]: ADDITIONAL_METRICS,
    [DataRouting.SUBJECT_ANSWERS]: PRACTICE_QUESTIONS,
    [DataRouting.SUBJECT_REVIEWS]: REVIEWS,
    [DataRouting.SUBJECT_ACTIVITIES]: ACTIVITIES,
    [DataRouting.SUBJECT_ASSIGNED_EXERCISES]: ACTIVITIES,
    [DataRouting.SUBJECT_COMPLETED_EXERCISES]: ACTIVITIES,
    [DataRouting.SUBJECT_QUESTION_BUILDERS]: ADDITIONAL_METRICS,
    [DataRouting.SUBJECT_TEACHER_PICKS]: ACTIVITIES,
    [DataRouting.SUBJECT_ANSWERS_SHORT]: ADDITIONAL_METRICS,
    [DataRouting.SUBJECT_READING_LEVELS]: ADDITIONAL_METRICS,
    [DataRouting.SUBJECT_READING_LEVEL_GRAPH]: ADDITIONAL_METRICS,
    [DataRouting.SUBJECT_ESSAYS]: ADDITIONAL_METRICS,
}


// WEBPACK FOOTER //
// ./modules/lib/data/DataExportMetrics.js